import React from 'react';
import { Table, Button, Popconfirm, notification } from 'antd';
import { DeleteOutlined, EditOutlined, PlusOutlined } from '@ant-design/icons';
import { PageContainer } from '@ant-design/pro-layout';
import { AuthContext } from 'context/AuthContext';
import { useNavigate, useParams } from 'react-router-dom';
import roleService from 'services/role.services';
import AddForm from './components/AddForm';
import CheckAuth from '../../components/common/CheckAuth';
import authorities from '../../helpers/authorities';

class Role extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      roles: [],
      loading: false,
      submitting: false,
      visibleAdd: false,
      currentMerch: context?.selectedMerch,
      error: null,
      selectedRole: null,
      columns: [
        {
          title: <div className="table-title-calibri-bold-12">Adı</div>,
          dataIndex: 'name',
          key: 'name',
          align: 'center',
          width: 200,
          render: (text, row) => {
            return <span className="table-title-calibri-bold-12">{row.name}</span>;
          },
        },
        {
          title: <div className="table-title-calibri-bold-12">İşlemler</div>,
          dataIndex: 'identifier',
          key: 'actions',
          fixed: 'right',
          width: 300,
          render: (id, record) => (
            <>
              <CheckAuth authorityCode={authorities.UPDATE_ROLE}>
                <Button
                  type="ghost"
                  onClick={() => {
                    this.handleOpenAddForm();
                    this.setState({ selectedRole: record });
                  }}
                >
                  <EditOutlined />
                </Button>
              </CheckAuth>
              <CheckAuth authorityCode={authorities.DELETE_ROLE}>
                <Popconfirm
                  title="Rolu silmek ister misiniz?"
                  okText="Evet"
                  cancelText="Hayır"
                  onConfirm={async () => {
                    await this.deleteRole(id);
                  }}
                  placement="topRight"
                >
                  <Button className="ml-3" type="danger">
                    <DeleteOutlined />
                  </Button>
                </Popconfirm>
              </CheckAuth>
            </>
          ),
        },
      ],
    };
  }

  componentDidMount() {
    this.getRoles();
  }

  getRoles = async () => {
    try {
      this.setState({ loading: true });
      const number = this.context?.selectedMerch?.number;
      const { payload } = await roleService.getRoles(number);
      this.setState({ roles: payload, loading: false });
    } catch (error) {
      console.log(error.message);
      notification.error({
        message: 'İşlem Başarısız',
        description: 'Roller getirilemedi.',
      });
      this.setState({ roles: [], loading: false });
    }
  };

  handleSubmitAddForm = async (values) => {
    const { selectedRole } = this.state;
    try {
      const number = this.context?.selectedMerch?.number;
      this.setState({ loading: true, submitting: true });
      if (!selectedRole) {
        await roleService.addRole(number, values);
        notification.success({
          message: 'İşlem Başarılı',
          description: 'Rol eklendi.',
        });
      } else {
        await roleService.editRole(selectedRole?.identifier, values);
        notification.success({
          message: 'İşlem Başarılı',
          description: 'Rol güncellendi.',
        });
      }
      await this.getRoles();
      this.setState({ loading: false, submitting: false });
      this.handleCloseAddForm();
    } catch (error) {
      console.log(error.message);
      notification.error({
        message: 'İşlem Başarısız',
        description: selectedRole ? 'Rol güncellenemedi.' : 'Rol eklenemedi.',
      });
      this.setState({ loading: false, submitting: false });
    }
  };

  handleOpenAddForm = () => {
    this.setState({ visibleAdd: true });
  };

  handleCloseAddForm = () => {
    this.setState({ visibleAdd: false, error: null, selectedRole: null });
  };

  deleteRole = async (roleId) => {
    try {
      await roleService.deleteRole(roleId);
      await this.getRoles();
      notification.success({
        message: 'İşlem Başarılı',
        description: 'Rol silindi.',
      });
    } catch (error) {
      console.log(error.message);
      notification.error({
        message: 'İşlem Başarısız',
        description: 'Rol silinemedi.',
      });
    }
  };

  render() {
    const { roles, loading, submitting, visibleAdd, columns, error, selectedRole } = this.state;
    return (
      <PageContainer
        title="Rol İşlemleri"
        extra={[
          <CheckAuth key="1" authorityCode={authorities.ADD_ROLE}>
            <Button
              disabled={loading}
              key="1"
              type="primary"
              icon={<PlusOutlined />}
              onClick={() => {
                this.handleOpenAddForm();
              }}
            >
              Ekle
            </Button>
          </CheckAuth>,
        ]}
      >
        <Table
          loading={loading}
          dataSource={roles}
          columns={columns}
          pagination={false}
          rowKey="identifier"
        />
        {visibleAdd && (
          <AddForm
            selectedRole={selectedRole}
            submitting={submitting}
            error={error}
            visible={visibleAdd}
            handleCloseForm={this.handleCloseAddForm}
            handleSubmitForm={this.handleSubmitAddForm}
          />
        )}
      </PageContainer>
    );
  }
}

Role.contextType = AuthContext;

const RoleWrapper = (props) => {
  const navigate = useNavigate();
  const params = useParams();
  return <Role {...props} navigate={navigate} params={params} />;
};

export default RoleWrapper;
